import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function phoneNumberValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;
    if (!value) return null;
    return isValidPhoneNumber(value) ? null : { invalidPhone: true };
  };
}

export function isValidPhoneNumber(rawInput: string): boolean {
  const digits = rawInput.replace(/\D/g, '');
  const cleaned = digits.length === 11 && digits.startsWith('1') ? digits.slice(1) : digits;

  if (cleaned.length !== 10) return false;

  const area = cleaned.slice(0, 3);
  const exchange = cleaned.slice(3, 6);

  const invalidAreaCodes = ['211', '311', '411', '511', '611', '711', '811', '911', '456', '555'];
  const invalidExchangeCodes = ['000', '211', '311', '411', '511', '611', '711', '811', '911', '555'];

  // Area code must be 200–999, not in the invalid list, and not ending in 00
  if (!/^[2-9]\d{2}$/.test(area) || invalidAreaCodes.includes(area) || area.endsWith('00')) {
    return false;
  }

  // Exchange code must be 200–999 and not in the invalid list
  if (!/^[2-9]\d{2}$/.test(exchange) || invalidExchangeCodes.includes(exchange)) {
    return false;
  }

  return true;
}
